import axios from "axios";
import {
  GET_ALL_LEAVE_REQUEST,
  GET_ALL_LEAVE_SUCCESS,
  GET_ALL_LEAVE_FAIL,
} from "../../types/admin/allLeavesTypes";

export const getAllLeaveAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_ALL_LEAVE_REQUEST,
    });

    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };

    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }

    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/auth-dashboard/all-leaves/`,
      config
    );
    dispatch({
      type: GET_ALL_LEAVE_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);

    if (!err) {
      err = "Network Error";
    }

    dispatch({
      type: GET_ALL_LEAVE_FAIL,
      payload: err,
    });

    throw err;
  }
};
